import styled from "@emotion/styled";
import { lightGreen, SPACE_MONO } from "@stepfinance/react";
import type { ProgressProps } from "antd";
import { Progress } from "antd";
import type { CSSProperties, FC } from "react";

interface StepProgressProps extends ProgressProps {
  legend?: string | number;
  legendStyle?: CSSProperties;
}

export const StepProgress: FC<StepProgressProps> = (props) => {
  return (
    <ProgressContainer>
      {props.legend && (
        <p style={props.legendStyle} className="progress-legend">
          {props.legend}
        </p>
      )}
      <Progress
        {...props}
        status={props.percent === 100 ? "normal" : "active"}
        strokeColor={lightGreen}
        showInfo
        type="line"
        className="step-progress"
      />
    </ProgressContainer>
  );
};

const ProgressContainer = styled.div`
  .step-progress {
    .ant-progress-outer {
      width: 95%;
      .ant-progress-inner {
        .ant-progress-bg {
          height: 25px !important;
          transition: all 5.5s cubic-bezier(0.08, 0.82, 0.17, 1) 0s;
        }
      }
    }
    .ant-progress-text {
      font-size: 16px;
      font-weight: bold;
      font-family: ${SPACE_MONO};
    }
  }
  .progress-legend {
    margin: 0;
    margin-bottom: 8px;
    padding-right: calc(2em + 8px);
    width: 95%;
    font-size: 16px;
    display: flex;
    justify-content: center;
  }
`;
